<template lang="html">

  <section class="ofertas-home">

    <template v-if="ofertas.practicas.length != 0 || ofertas.empleo.length != 0">

      <nav class="selector-tipo row-start">
        <!-- <a v-if="!!candidaturas" :active="how == 1" @click="how = 1">Candidaturas</a> -->
        <a v-if="ofertas.practicas.length > 0 && !soloCiclosUAX" :active="(how == 2) ? 'true' : 'false'" @click="how = 2">
          <span class="pc">{{$t('ofertas.ultimas_practicas')}}</span>
          <span class="mvl">Prácticas</span>
        </a>
        <a v-if="ofertas.empleo.length > 0" :active="(how == 3) ? 'true' : 'false'" @click="how = 3">
          <span class="pc">{{$t('ofertas.ultimas_empleo')}}</span>
          <span class="mvl">{{$t('ofertas.empleo')}}</span>
        </a>
      </nav>


      <template v-if="!itsLoader">
        <oferta-el--fake :key="'fake'+key" v-for="(oferta, key) in 4"></oferta-el--fake>
      </template>


      <template v-if="!!candidaturas">

        <div class="ofertas-list" v-show="how == 1">
          <oferta-el v-for="(oferta, key) in candidaturas.practicas.slice(0,4)" :key="`practicas-${key}`" :data="oferta"
            :type="'practicas'"></oferta-el>
          <oferta-el v-for="(oferta, key) in candidaturas.empleo.slice(0,4)" :key="`empleo-${key}`" :data="oferta"
            :type="'empleo'"></oferta-el>
          <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.mis_candidaturas')"></arrow-link>
        </div>

      </template>

      <template v-if="!!ofertas">

        <div class="ofertas-list" v-if="ofertas.practicas.length > 0" v-show="how == 2">
          <oferta-el v-for="(oferta, key) in ofertas.practicas.slice(0,5)" :key="`practicas-${key}`" :data="oferta"
            :type="'practicas'"></oferta-el>
          <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
          <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_practicas')"></arrow-link>
        </div>
        </div>

        <div class="ofertas-list" v-if="ofertas.empleo.length > 0" v-show="how == 3">
          <oferta-el v-for="(oferta, key) in ofertas.empleo.slice(0,5)" :key="`empleo-${key}`" :data="oferta"
            :type="'empleo'"></oferta-el>
          <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
          <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_empleo')"></arrow-link>
        </div>

      </template>

    </template>

    <template v-else>
      <div class="sin-ofertas" v-if="(params.empleo.numPaginas == 0 || !!!params.empleo) && (params.practicas.numPaginas == 0 || !!!params.practicas) && ofertasloaded">

        <h2>{{$t('ofertas.ofertas')}}</h2>
        <p>{{$t('ofertas.zero_ofertas')}}</p>
      </div>


      <loading v-else :small="true"></loading>

    </template>


  </section>

</template>

<script lang="js">

  import { mapGetters } from 'vuex'

  import ofertaEl from './oferta-el';
  import fakeofertaEl from './oferta-el--fake';

  import arrowLink from '@/components/parts/icons/arrow-link';


  import loadingView from '@/components/parts/loading';

  export default {
    name: 'modulo-ofertas',
    data() {
      return {
        how: (!this.soloCiclosUAX) ? 3 : 2
      }
    },
    mounted() {
      if (this.ofertas.empleo.length > 0) {
        this.how = 3;
      }else{
        this.how = 2;
      }
    },
    computed: {
      ...mapGetters({
        style: 'getStyles',
        ofertas: 'getOfertas',
        candidaturas: 'getCandidaturas',
        colors: 'basicColors',
        params : 'getParamsOfertas',
        soloCiclosUAX : 'getsoloCiclosUAX',
        ofertasloaded : 'getofertasloaded'
      }),
      itsLoader: function () {
        let flag = true;
        
        if (this.ofertas.empleo.length == 0 && this.ofertas.practicas.length == 0) {
          if (this.candidaturas.empleo.length == 0 && this.candidaturas.practicas.length == 0) {
            flag = false;
          }
        }

        return flag;
      },
      ownstyles: function () {
        return {
          selectorTipo: {
            'border-top': `4px solid ${(!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic}`,
            'background': `${(!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic}`,
            'color': (!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic
          },
          verTodas: {
            'border-top': `1px solid ${this.colors.soft_black}`
          }
        }
      }
    },
    components: {
      'oferta-el': ofertaEl,
      'oferta-el--fake': fakeofertaEl,
      'arrow-link': arrowLink,
      'loading': loadingView,
    },
    watch: {
      'ofertas.empleo': function () {
        if (this.ofertas.practicas.length == 0 && this.ofertas.empleo.length > 0) {
          this.how = 3;
        }
      },
      'ofertas.practicas': function () {
        if (this.ofertas.empleo.length == 0 && this.ofertas.practicas.length > 0) {
          this.how = 2;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .ofertas-home {
    width: 100%;
  }

  .contenedor-ver-todas {
    margin-top: 20px;
    padding-top: 20px;
  }

  .arrow-link {
    /*margin-top: 10px;*/
  }

  .sin-ofertas h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-bottom: 20px;
  }

  .sin-ofertas p{
    text-align: center;
    display: inline-block;
  }

  @media screen and (max-width: 600px) {
    .selector-tipo a {
      border-right: none;
      padding-right: 5px;
      padding-left: 5px;
      width: 50%;
      margin-right: 0;
      font-size: 12px;
      height: 40px;
      line-height: 40px;
      margin-top: 0;
    }

    .selector-tipo a:last-of-type:first-of-type {
      width: 100%;
    }
  }


  @media screen and (max-width: 480px) {

    .selector-tipo a {
      font-size: 16px;
      span.pc {
        display: none;
      }

      span.mvl {
        display: block;
      }
    }


  }

</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-ofertas.vue